import { Link } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { SERVICES } from "@/data/services";
import { LOCATIONS } from "@/data/areas";
import { ServiceIcon } from "@/lib/icons";
import { SITE } from "@/lib/site";

const itemCls = "flex items-center gap-3 rounded-xl px-3 py-2.5 text-[15px] font-semibold text-brand-anthracite hover:bg-brand-mist";

export const MobileNav = ({ open, onOpenChange }) => {
  const close = () => onOpenChange(false);
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-[88vw] max-w-sm overflow-y-auto bg-white p-0" data-testid="mobile-nav">
        <div className="bg-brand-yellow px-5 py-5">
          <SheetTitle className="text-lg font-bold text-brand-anthracite">Menü</SheetTitle>
        </div>
        <nav className="space-y-1 p-3" aria-label="Mobile Navigation">
          <p className="px-3 pb-1 pt-2 text-xs font-bold uppercase tracking-wider text-brand-blue">Leistungen</p>
          {SERVICES.map((s) => (
            <Link key={s.slug} to={`/${s.slug}`} onClick={close} className={itemCls} data-testid={`mobile-nav-${s.slug}`}>
              <ServiceIcon name={s.icon} className="h-5 w-5 text-brand-blue" /> {s.name}
            </Link>
          ))}
          <div className="my-2 h-px bg-slate-100" />
          <p className="px-3 pb-1 pt-2 text-xs font-bold uppercase tracking-wider text-brand-blue">Einsatzgebiet</p>
          <div className="grid grid-cols-2 gap-x-1">
            {LOCATIONS.map((l) => (
              <Link key={l.slug} to={`/${l.slug}`} onClick={close} className="rounded-lg px-3 py-1.5 text-sm font-semibold text-brand-anthracite hover:bg-brand-mist" data-testid={`mobile-nav-${l.slug}`}>
                {l.kind === "koeln" ? l.name : l.label}
              </Link>
            ))}
          </div>
          <Link to="/einsatzgebiet" onClick={close} className={itemCls} data-testid="mobile-nav-areas">Gesamtes Einsatzgebiet</Link>
          <div className="my-2 h-px bg-slate-100" />
          <Link to="/faq" onClick={close} className={itemCls} data-testid="mobile-nav-faq">FAQ</Link>
          <Link to="/kontakt" onClick={close} className={itemCls} data-testid="mobile-nav-contact">Kontakt & Anfahrt</Link>
          <Link to="/schaden-melden" onClick={close} className={itemCls} data-testid="mobile-nav-damage">Schaden melden</Link>
        </nav>
        <div className="space-y-2 p-5">
          <a href={SITE.phoneHref} className="flex items-center justify-center gap-2 rounded-xl bg-brand-blue py-3 font-bold text-white" data-testid="mobile-nav-call">
            <Phone className="h-4 w-4" /> {SITE.phone}
          </a>
          <a href={SITE.whatsappHref} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 rounded-xl bg-brand-whatsapp py-3 font-bold text-brand-anthracite" data-testid="mobile-nav-whatsapp">
            <MessageCircle className="h-4 w-4" /> WhatsApp
          </a>
        </div>
      </SheetContent>
    </Sheet>
  );
};
